import Cookies from 'js-cookie'
import axios from 'axios'

export const debounce = (fn: Function, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId)
    // eslint-disable-next-line no-invalid-this
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}

export const urlParamsToObject = (source: string) => {
  if (!source) return

  const params = new URLSearchParams(source)
  const entries = params.entries()

  const result = {}

  // @ts-ignore
  for (const [key, value] of entries) {
    // @ts-ignore
    result[key] = value
  }

  return result
}

export const checkAuth = () => {
  const token = Cookies.get('PdboxTicket')

  return !!token
}

export const ONGformat = (value: number) => {
  return value.toLocaleString('de-DE')
}

export const generateSearchUrl = (keyword: string, isMobile?: boolean) => {
  if (isMobile) {
    return `https://m.onlive.vn/#/search/${keyword}`
  } else {
    return (
      process.env.NEXT_PUBLIC_ONLIVE +
      `/search/?szLocation=main&szSearchType=total&szKeyword=${keyword}&szStype=di&szActype&has_hint=false&pk_cnt=0`
    )
  }
}

export const getBjAvatar = (bjId: string) => {
  if (!bjId) return ''

  return (
    process.env.NEXT_PUBLIC_STIMG +
    '/LOGO/' +
    bjId.substring(0, 2) +
    '/' +
    bjId +
    '/' +
    bjId +
    '.jpg'
  )
}

export const getTitleHeaderNotification = (notiList: any[]) => {
  for (const value of Object.values(notiList)) {
    switch (value.NOTI_TYPE) {
      case 'F01':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> bắt đầu phát sóng: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_PLAY +
          '/' +
          value.FROM_ID +
          '/' +
          value.COMMON_NO
        break
      case 'F02':
        value.NOTI_TITLE =
          'Bài đăng của <span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span>: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.FROM_ID +
          '/post' +
          value.COMMON_NO
        break
      case 'F03':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tải lên VOD mới'
        value.URL = process.env.NEXT_PUBLIC_VOD + '/player/' + value.COMMON_NO
        break
      case 'F06':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã đăng bài viết mới tại sổ ghi danh: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER + '/' + value.FROM_ID + '/guest'
        break
      case 'F12':
        value.NOTI_TITLE =
          'Quản trị viên của <span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã đăng bài viết mới: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.STATION_OWNER +
          '/post/' +
          value.COMMON_NO
        break
      case 'A01':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã bình luận về bài viết của bạn: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.USER_ID +
          '/post/' +
          value.COMMON_NO +
          '#comment_noti' +
          value.SUB_COMMON_NO
        break
      case 'A02':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã bình luận về VOD của bạn: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_VOD +
          '/player/' +
          value.COMMON_NO +
          '/?comment_no=' +
          value.SUB_COMMON_NO +
          '&noti_type=parent'
        break
      case 'A03':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã bình luận về bài viết tại danh sách ghi danh của bạn: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.FROM_ID +
          '/guest#comment_noti' +
          value.COMMON_NO
        break
      case 'A04':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã trả lời bình luận của bạn: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.USER_ID +
          '/post/' +
          value.COMMON_NO +
          '#reply_noti' +
          value.SUB_COMMON_NO
        break
      case 'A05':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã trả lời bình luận của bạn: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_VOD +
          '/player/' +
          value.COMMON_NO +
          '/?comment_no=' +
          value.SUB_COMMON_NO +
          '&noti_type=child'
        break
      case 'A07':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã cổ vũ bài viết của bạn'
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.STATION_OWNER +
          '/post/' +
          value.COMMON_NO
        break
      case 'A08':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã cổ vũ VOD của bạn'
        value.URL = process.env.NEXT_PUBLIC_VOD + '/player/' + value.COMMON_NO
        break
      case 'A09':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã cổ vũ bình luận của bạn'
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.STATION_OWNER +
          '/post/' +
          value.COMMON_NO +
          '#comment_noti' +
          value.SUB_COMMON_NO
        break
      case 'A10':
        value.NOTI_TITLE = ' đã cổ vũ bình luận của bạn'
        value.URL =
          process.env.NEXT_PUBLIC_VOD +
          '/player/' +
          value.COMMON_NO +
          '/?referer=noti&comment_no=' +
          value.SUB_COMMON_NO +
          '&noti_type=parent'
        break
      case 'A11':
        value.NOTI_TITLE =
          'Thông báo từ <span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span>: ' +
          value.HEAD_TEXT
        if (value.NOTE_TYPE == 'INTERACTIVE') {
          value.URL =
            process.env.NEXT_PUBLIC_MINIGAME +
            '/notifications/' +
            value.INTERACTIVE_NO
        } else {
          value.URL =
            process.env.NEXT_PUBLIC_NOTE +
            '/app/index.php?page=recv_view&no=' +
            value.COMMON_NO
        }
        break
      case 'A12':
        value.NOTI_TITLE =
          'Xem thêm bình luận của <span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span>: Bạn có muốn để lại phản hồi cho người dùng đã trả lời cho nhận xét của bạn không?'
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.STATION_OWNER +
          '/post/' +
          value.COMMON_NO +
          '#comment_noti' +
          value.SUB_COMMON_NO
        break
      case 'A13':
        value.NOTI_TITLE =
          'Xem thêm bình luận của <span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span>: Bạn có muốn để lại phản hồi cho người dùng đã trả lời cho nhận xét của bạn không?'
        value.URL =
          process.env.NEXT_PUBLIC_VOD +
          '/player/' +
          value.COMMON_NO +
          '/?referer=noti&comment_no=' +
          value.SUB_COMMON_NO +
          '&noti_type=parent'
        break
      case 'B02':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã để lại bài viết trên Blog của bạn: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.STATION_OWNER +
          '/post/' +
          value.COMMON_NO
        break
      case 'B03':
        value.NOTI_TITLE =
          'Quản trị viên đã tải lên một VOD trên Blog của bạn: ' +
          value.HEAD_TEXT
        value.URL = process.env.NEXT_PUBLIC_VOD + '/player/' + value.COMMON_NO
        break
      case 'B04':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tải lên VOD từ livestream của bạn với tư cách Streamer'
        value.URL = process.env.NEXT_PUBLIC_VOD + '/player/' + value.COMMON_NO
        break
      case 'B06':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã bình luận về bài viết tại sách ghi danh của bạn: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_STREAMER +
          '/' +
          value.STATION_OWNER +
          '/guest'
        break
      case 'B07':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã ẩn VOD của bạn: ' +
          value.HEAD_TEXT
        value.URL = process.env.NEXT_PUBLIC_VOD + '/player/' + value.COMMON_NO
        break
      case 'S01':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tặng ' +
          value.GIFT_COUNT +
          ' Bóng bay trên livestream của bạn'
        value.URL =
          process.env.NEXT_PUBLIC_POINT + '/mygift-starballoon#received'
        break
      case 'S02':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tặng ' +
          value.GIFT_COUNT +
          ' Bóng bay trên VOD của bạn'
        value.URL =
          process.env.NEXT_PUBLIC_POINT + '/mygift-starballoon#received'
        break
      case 'S03':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tặng ' +
          value.GIFT_COUNT +
          ' Bóng bay trên VOD từ livestream của bạn với tư cách Streamer'
        value.URL =
          process.env.NEXT_PUBLIC_POINT + '/mygift-starballoon#received'
        break
      case 'S05':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tặng ' +
          value.GIFT_COUNT +
          ' Sticker trên livestream của bạn'
        value.URL = process.env.NEXT_PUBLIC_POINT + '/mygift-sticker#received'
        break
      case 'S04':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tặng ' +
          value.GIFT_COUNT +
          ' Bóng bay đến Blog của bạn'
        value.URL =
          process.env.NEXT_PUBLIC_POINT + '/mygift-starballoon#received'
        break
      case 'S06':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tặng ' +
          value.GIFT_COUNT +
          ' Sticker đến Blog của bạn'
        value.URL = process.env.NEXT_PUBLIC_POINT + '/mygift-sticker#received'
        break
      case 'S08':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã tặng ' +
          value.GIFT_COUNT +
          ' Bóng bay VOD trên livestream của bạn'
        value.URL =
          process.env.NEXT_PUBLIC_POINT + '/mygift-starballoon#received'
        break
      case 'S11':
      case 'S12':
      case 'S13':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã đăng ký'
        value.URL =
          process.env.NEXT_PUBLIC_POINT + '/mygift-subscription/#cashout'
        break
      case 'C11':
      case 'C21':
      case 'C31':
        value.NOTI_TITLE =
          'Trung tâm bình luận từ <span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span>: ' +
          value.HEAD_TEXT
        value.URL =
          process.env.NEXT_PUBLIC_SUPPORT +
          '/report/?board_type=report&work=view&b_no=' +
          value.COMMON_NO +
          '&referer=noti&comment_no=' +
          value.SUB_COMMON_NO +
          '&comment_type=parent'
        break
      case 'C14':
      case 'C24':
      case 'C34':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã trả lời bình luận của bạn trên trang Hỗ trợ'
        value.URL =
          process.env.NEXT_PUBLIC_SUPPORT +
          '/report/?board_type=report&work=view&b_no=' +
          value.COMMON_NO +
          '&referer=noti&comment_no=' +
          value.SUB_COMMON_NO +
          '&comment_type=child'
        break
      case 'C19':
      case 'C29':
      case 'C39':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã cổ vũ bài viết'
        value.URL =
          process.env.NEXT_PUBLIC_SUPPORT +
          '/report/?board_type=report&work=view&b_no=' +
          value.COMMON_NO +
          '&referer=noti&comment_no=' +
          value.SUB_COMMON_NO +
          '&comment_type=parent'
        break
      case 'C17':
      case 'C27':
      case 'C37':
        value.NOTI_TITLE =
          '<span class="noti-name">' +
          value.FROM_NICKNAME +
          '</span> đã cổ vũ bài viết'
        value.URL =
          process.env.NEXT_PUBLIC_SUPPORT +
          '/report/?board_type=report&work=view&b_no=' +
          value.COMMON_NO
        break
    }
  }
  return notiList
}
export const formatNumber = (num: string) => {
  return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0'
}
export const formatImgUrl = (url: string) => {
  return url && url?.startsWith('https://')
    ? url
    : url?.startsWith('//')
    ? `https:${url}`
    : `https://${url}`
}
export const handleToken = async () => {
  const tokenOidc = Cookies.get('access_token')
  const refreshOidc = Cookies.get('refresh_token')
  if (!refreshOidc) {
    Cookies.remove('PdboxTicket')
  }
  if (!tokenOidc && refreshOidc) {
    const newTokenObj = await refreshToken(refreshOidc)
    if (newTokenObj) {
      const vrfToken = await verifyToken(
        newTokenObj.access_token,
        'access_token',
      )
      const vrfRefresToken = await verifyToken(
        newTokenObj.refresh_token,
        'refresh_token',
      )
      if (vrfRefresToken && vrfToken) {
        setCookieOidc('access_token', newTokenObj.access_token, vrfToken.exp)
        setCookieOidc('expires_in', vrfToken.exp, vrfToken.exp)
        setCookieOidc(
          'refresh_token',
          newTokenObj.refresh_token,
          vrfRefresToken.exp,
        )
      }
    }
  }
}
export const setCookieOidc = (name: string, value: string, time: any) => {
  const now = new Date(time * 1000)
  now.setTime(now.getTime())
  document.cookie =
    name +
    '=' +
    value +
    ';domain=.onlive.vn;expires=' +
    now.toUTCString() +
    ';Path=/;'
}
export const refreshToken = async (refreshOidc: string) => {
  try {
    const body = {
      grant_type: 'refresh_token',
      refresh_token: refreshOidc,
    }
    const api = process.env.NEXT_PUBLIC_SERVICE + '/api/verify-token'
    return await axios.post(api, body).then((res) => {
      if (res.data.IsSuccessed) {
        return res.data.data
      }
      throw new Error('API Error')
    })
  } catch (err: any) {
    console.log(err.message)
    return false
  }
}
export const verifyToken = async (newToken: string, type: string) => {
  try {
    const api = process.env.NEXT_PUBLIC_SERVICE + '/api/token-introspection'
    if (!type) {
      throw new Error('Type Error')
    }
    const body = {
      token_type_hint: type,
      token: newToken,
    }
    return await axios.post(api, body).then((res) => {
      if (res.data.IsSuccessed) {
        return res.data.data
      }
      throw new Error('API Error')
    })
  } catch (err) {
    return null
  }
}
